import { BILLING_API } from '@Constants/backendConstants';
import {
    EnumOperation,
    ListRequest,
    FilterCondition,
    EnumFilterExpressionOperation,
} from '@synqo/frontend-component-library';
import { EnumInvoiceType, EnumProcessState } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { InvoicesRepository } from '@Repositories/Billing';

export function useLoadUnpaidInvoices() {
    const listApi = useListApi(InvoicesRepository, BILLING_API, ['all']);

    function loadPage(listRequest: ListRequest) {
        const oposFilters: FilterCondition[] = [
            {
                field: 'process_state',
                value: EnumProcessState.Approved.toString(),
                operator: EnumOperation.Equal,
            },
            {
                field: 'type',
                value: EnumInvoiceType.Cancellation.toString(),
                operator: EnumOperation.NotEqual,
            },
            { field: 'payment_completed_at', value: '', operator: EnumOperation.Equal },
            { field: 'related_cancellation.foreign_key', value: '', operator: EnumOperation.Equal },
            { field: 'total_gross_price', value: '0', operator: EnumOperation.NotEqual },
        ];

        if (listRequest.filter_columns === undefined) {
            listRequest.filter_columns = { operation: EnumFilterExpressionOperation.And, filters: [] };
        }

        listRequest.filter_columns.filters.push(...oposFilters);

        return listApi.loadPage(listRequest);
    }

    return {
        loadPage,
    };
}
